/* -----------------Globals--------------- */
import { useCallback } from "react";

/* -----------------Child components--------------- */
import StudySessionView from "../components/StudySessionView";

import { useAuthContext } from "@memorang/applets";
import { isUuid } from "@memorang/helpers";
import { useFocusEffect, useLocalSearchParams, useRouter } from "expo-router";
/* -----------------Helpers & Hooks--------------- */
import useSessionStore from "../hooks/useSessionStore";

/* -----------------UI--------------- */
import { Loader } from "@memorang/ui";

import MoreItemsAlertDialog from "../components/dialogs/MoreItemsAlertDialog";
/* -----------------Types--------------- */
import { useResumeSession } from "../hooks/useResumeSession";

type Props = {
	reviewMode?: boolean;
};

const SessionContainer = ({ reviewMode }: Props) => {
	const sessionItems = useSessionStore((state) => state.sessionItems);
	const numItemsRequested = useSessionStore((state) => state.numItemsRequested);
	const sessionId = useSessionStore((state) => state.id);
	const showMoreItemsAlert = useSessionStore(
		(state) => state.showMoreItemsAlert,
	);

	const toggleShowMoreItemsAlert = useSessionStore(
		(state) => state.toggleShowMoreItemsAlert,
	);
	const { handleResumeSession } = useResumeSession();
	const { viewerId } = useAuthContext();
	const router = useRouter();

	const { id, index } = useLocalSearchParams<{
		id: string;
		index?: string;
	}>();

	// Focus-gated: a /session screen left mounted in the back stack must never
	// re-arm when another flow resets the store (resetSessionStore -> id 0 used
	// to re-trigger this and resume the just-ended session, IMP-3850). Resume
	// replaces (not pushes) so this URL never stacks a duplicate of itself.
	useFocusEffect(
		useCallback(() => {
			if (!sessionId && viewerId && id) {
				const sessionNumericId = isUuid(id) ? undefined : Number(id);
				if (sessionNumericId) {
					handleResumeSession({
						numericId: sessionNumericId,
						replace: true,
						reviewMode,
						reviewIndex: index ? Number.parseInt(index) - 1 : undefined,
					}).then((status) => {
						if (status === "failed") {
							router.replace("/home");
						}
					});
				} else {
					router.replace("/home");
				}
			}
		}, [
			handleResumeSession,
			id,
			index,
			reviewMode,
			router,
			sessionId,
			viewerId,
		]),
	);

	if (!sessionId) {
		return <Loader />;
	}

	return (
		<>
			<StudySessionView sessionItems={sessionItems} />
			{showMoreItemsAlert && (
				<MoreItemsAlertDialog
					visible={showMoreItemsAlert}
					handleClose={toggleShowMoreItemsAlert}
					numItemsAvailable={sessionItems.length}
					numItemsRequested={numItemsRequested}
				/>
			)}
			{/* <AudioPlaybackTestDialog
				showDialog={showAudioPlaybackTestDialog}
				handleClose={() => {
					setShowAudioPlaybackTestDialog(false);
				}}
			/> */}
		</>
	);
};

export default SessionContainer;
